import { show, getComponentPart, getComponentParts } from "./common";
import PrintingDemand from "./printing-demand";
import QuantityEdit from "./quantity-edit";

export default class PrintingTechnologySelector {
    private baseElement: HTMLElement;
    private technologySelectedCallback: (demand: PrintingOnlineDemand) => void;
    private selectedTechnology: PrintingTechnology;
    private printingDescriptionContainer: HTMLElement;
    private demandComponent: PrintingDemand;
    private positionName: string;
    private quantityEdit: QuantityEdit;
    private isCalculatorActive: boolean;
    private isProductOutOfStock: boolean;

    private detailsContainerPartName = 'PrintingDetailsContainer';
    private technologyLinkPartName = 'technology-link';

    constructor(baseElement: HTMLElement, technologySelectedCallback: (demand: PrintingOnlineDemand) => void, productCount: number, isCalculatorActive: boolean, isProductOutOfStock: boolean) {
        this.baseElement = baseElement;
        this.isCalculatorActive = isCalculatorActive;
        this.isProductOutOfStock = isProductOutOfStock;
        this.printingDescriptionContainer = getComponentPart(this.baseElement, this.detailsContainerPartName);
        this.positionName = this.baseElement.dataset.positionName;
        this.demandComponent = new PrintingDemand(this.printingDescriptionContainer, (demandText) => this.continue(demandText));
        this.technologySelectedCallback = technologySelectedCallback;
        const technologyElements = getComponentParts(this.baseElement, this.technologyLinkPartName);
        technologyElements.forEach(element => this.initTechnologyLink(element as HTMLAnchorElement));
        const quantityEditElement = this.baseElement.querySelector('[data-component-part="quantity-edit"]') as HTMLElement;
        if(quantityEditElement) {
            this.quantityEdit = new QuantityEdit(quantityEditElement);
            this.quantityEdit.setValue(productCount);
        }
    }

    private initTechnologyLink(element: HTMLAnchorElement): void {
        element.addEventListener('click', evt => {
            evt.preventDefault();
            const link = evt.currentTarget as HTMLAnchorElement;    
            this.technologySelected(link.dataset.technologyId, link.dataset.technologyName);
        })
    }

    private continue(demandText: string): void {
        demandText && this.technologySelectedCallback && 
        this.technologySelectedCallback({technology: this.selectedTechnology, demandText: demandText, productCount: this.getProductCount() });
    }

    private getProductCount(): number{
        return this.quantityEdit ? this.quantityEdit.getValue() : NaN;
    }

    private technologySelected(technologyId: string, technologyName: string) {
        this.selectedTechnology = { name: technologyName, id: technologyId }
        if (this.isProductOutOfStock || this.isCalculatorActive) {
            this.technologySelectedCallback({technology: this.selectedTechnology, demandText: null, productCount: this.getProductCount() })
        }
        else {
            this.showPrintingDescription();
        }
    }

    private showPrintingDescription() {
        this.demandComponent.set(this.positionName, this.selectedTechnology.name);
        show(this.printingDescriptionContainer);
    }
}

export class PrintingTechnology{
    name: string;
    id: string;
}

export class PrintingOnlineDemand{
    technology: PrintingTechnology;
    demandText: string;
    productCount: number;
}
